import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { AnimationModule } from "../animation/animation.module";
import { AvatarModule } from "../avatar/avatar.module";
import { MaterialModule } from "../../../../modules/material/material.module";
import { PipesModule } from "../../pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";

import { SmallWebPreviewFrameComponent } from "./frames/smallWeb/small-web-preview-frame.component";
import { FullWebPreviewFrameComponent } from "./frames/fullWeb/full-web-preview-frame.component";
import { FullWebPreviewFrameImageComponent } from "./frames/fullWeb/full-web-preview-frame-image.component";
import { MobilePreviewFrameComponent } from "./frames/mobile/mobile-preview-frame.component";
import { MobilePreviewFrameImageComponent } from "./frames/mobile/mobile-preview-frame-image.component";

import { WebTopicsListPreviewComponent } from "./topics-list-preview/topics-list-preview.component";
import { MobileTopicsListPreviewComponent } from "./topics-list-preview/mobile-topics-list-preview.component";
import { WebSaysoCallPreviewComponent } from "./sayso-call-preview/sayso-call-preview.component";
import { MobileSaysoCallPreviewComponent } from "./sayso-call-preview/mobile-sayso-call-preview.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AnimationModule,
    AvatarModule,
    MaterialModule,
    PipesModule,
    TranslateModule
  ],
  declarations: [
    SmallWebPreviewFrameComponent,
    FullWebPreviewFrameComponent,
    FullWebPreviewFrameImageComponent,
    MobilePreviewFrameComponent,
    MobilePreviewFrameImageComponent,
    WebTopicsListPreviewComponent,
    MobileTopicsListPreviewComponent,
    WebSaysoCallPreviewComponent,
    MobileSaysoCallPreviewComponent
  ],
  exports: [
    SmallWebPreviewFrameComponent,
    FullWebPreviewFrameComponent,
    MobilePreviewFrameComponent,
    WebTopicsListPreviewComponent,
    MobileTopicsListPreviewComponent,
    WebSaysoCallPreviewComponent,
    MobileSaysoCallPreviewComponent
  ]
})
export class SaysoPreviewModule {}
